/**
 * Gestor diferido de analíticas con cola en memoria
 * Carga react-ga dinámicamente tras el evento load, primera interacción de usuario
 * o requestIdleCallback como respaldo.
 */

let ReactGAInstance = null;
let isInitializing = false;
const eventQueue = [];

const GA_TRACKING_ID = "G-65XQG4Y5N3";

export const initAnalytics = () => {
  if (typeof window === "undefined" || ReactGAInstance || isInitializing) return;

  const loadGA = () => {
    if (ReactGAInstance || isInitializing) return;
    isInitializing = true;

    // Retirar listeners una vez disparado el cargador
    window.removeEventListener("load", onTrigger);
    window.removeEventListener("scroll", onTrigger);
    window.removeEventListener("pointerdown", onTrigger);
    window.removeEventListener("keydown", onTrigger);
    window.removeEventListener("touchstart", onTrigger);

    import(/* webpackChunkName: "react-ga" */ "react-ga")
      .then((module) => {
        const ReactGA = module.default || module;
        ReactGA.initialize(GA_TRACKING_ID, {
          debug: false,
          gaOptions: {
            siteSpeedSampleRate: 100,
          },
        });
        ReactGAInstance = ReactGA;
        isInitializing = false;

        // Despachar eventos que se hayan encolado antes de la carga
        while (eventQueue.length > 0) {
          const item = eventQueue.shift();
          if (item.type === "event") {
            ReactGAInstance.event(item.payload);
          } else if (item.type === "pageview") {
            ReactGAInstance.pageview(item.payload);
          }
        }
      })
      .catch((err) => {
        isInitializing = false;
        console.warn("Analytics deferred load failed", err);
      });
  };

  const onTrigger = () => {
    loadGA();
  };

  if (document.readyState === "complete") {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadGA, { timeout: 3000 });
    } else {
      setTimeout(loadGA, 1500);
    }
  } else {
    window.addEventListener("load", onTrigger, { once: true, passive: true });
    window.addEventListener("scroll", onTrigger, { once: true, passive: true });
    window.addEventListener("pointerdown", onTrigger, { once: true, passive: true });
    window.addEventListener("keydown", onTrigger, { once: true, passive: true });
    window.addEventListener("touchstart", onTrigger, { once: true, passive: true });

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadGA, { timeout: 4000 });
    } else {
      setTimeout(loadGA, 2500);
    }
  }
};

export const trackEvent = (eventData) => {
  if (ReactGAInstance) {
    ReactGAInstance.event(eventData);
  } else {
    eventQueue.push({ type: "event", payload: eventData });
  }
};

export const trackPageView = (path) => {
  if (ReactGAInstance) {
    ReactGAInstance.pageview(path);
  } else {
    eventQueue.push({ type: "pageview", payload: path });
  }
};
